import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import MeasurementIcon from 'svg/measurement.svg';
import PolygonIcon from 'svg/polygon.svg';
import Time from '../partials/Time';
import styles from '../RelatedData.pcss';
const HbA1CTooltip = ({ HbA1CResource })=>{
    useStyles(styles);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.relatedDataTooltip,
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.relatedDataTooltip__content,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__title,
                    children: [
                        /*#__PURE__*/ _jsx(MeasurementIcon, {
                            className: styles.relatedDataTooltip__titleIcon
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.relatedDataTooltip__titleText,
                            children: "HbA1C"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.relatedDataTooltip__separator
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.relatedDataTooltip__details,
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: styles.relatedDataTooltip__detail,
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: styles.relatedDataTooltip__detailType,
                                    children: "HbA1C"
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: styles.relatedDataTooltip__detailValue,
                                    children: [
                                        HbA1CResource.value,
                                        "%"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Time, {
                            timeSeriesResource: HbA1CResource
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(PolygonIcon, {
                    width: "17",
                    height: "12",
                    className: styles.relatedDataTooltip__polygon
                })
            ]
        })
    });
};
export default HbA1CTooltip;
